import { gql } from '@apollo/client';

export const fetchInvoiceGroupDetailsForSubscriptionTablePPCQuery = gql`
  query fetchInvoiceGroupDetailsForSubscriptionTablePPC($id: ID!, $txaId: ID) {
    invoiceGroup(id: $id, txaId: $txaId) {
      id
      shipToParty {
        id
        name
        addressLine1
        addressLine2
        city
        country
        state
        postcode
      }
    }
  }
`;
